import { render, staticRenderFns } from "./thiet-lap-ky-so.vue?vue&type=template&id=19a8745d&scoped=true&"
import script from "./thiet-lap-ky-so.vue?vue&type=script&lang=js&"
export * from "./thiet-lap-ky-so.vue?vue&type=script&lang=js&"
import style0 from "./thiet-lap-ky-so.vue?vue&type=style&index=0&id=19a8745d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a8745d",
  null
  
)

export default component.exports